var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 855,
    height: 324,
    viewBox: "0 0 855 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_2857)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M0.5 261.789H150.146V316.593H213.171V261.789H251.838V208.964H213.171V4.8186H130.66L0.5 209.877V261.789ZM151.364 208.964H66.8739V206.528L148.928 76.673H151.364V208.964Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M426.575 323.444C504.975 323.444 552.32 263.768 552.472 161.01C552.624 59.0138 504.671 0.55603 426.575 0.55603C348.327 0.55603 300.83 58.8615 300.678 161.01C300.373 263.464 348.022 323.292 426.575 323.444ZM426.575 268.792C390.8 268.792 367.66 232.865 367.813 161.01C367.965 90.2217 390.952 54.599 426.575 54.599C462.045 54.599 485.185 90.2217 485.185 161.01C485.337 232.865 462.198 268.792 426.575 268.792Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M603.329 261.789H752.975V316.593H816V261.789H854.667V208.964H816V4.8186H733.489L603.329 209.877V261.789ZM754.193 208.964H669.703V206.528L751.757 76.673H754.193V208.964Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_2857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854.167,
    height: 322.888,
    fill: "white",
    transform: "translate(0.5 0.55603)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg404);
export default __webpack_public_path__ + "static/media/bg404.5592c93a2ebd52d1265ce2325affc33e.svg";
export { ForwardRef as ReactComponent };